// extracted by mini-css-extract-plugin
export var container = "_c7-0";
export var containerTopRight = "_c7-1";